import { testimonials, stats } from '@/mocks/testimonials';

export default function TestimonialSection() {

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            她们都在说
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            超过5000位女大学生的真实选择
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-10 md:mb-12">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-4 rounded-lg bg-background-100">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                {stat.value}{stat.suffix}
              </div>
              <div className="text-xs md:text-sm text-foreground-600 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.slice(0, 6).map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-4 md:p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center text-accent-600 font-heading font-bold text-sm">
                  {item.name[0]}
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {item.university}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-1 mb-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${
                      i < item.rating
                        ? 'ri-star-fill text-accent-500'
                        : 'ri-star-fill text-foreground-300'
                    }`}
                  />
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                "{item.content}"
              </p>
              <div className="mt-3 pt-3 border-t border-background-200/70 flex items-center justify-between">
                <span className="text-xs text-foreground-500">
                  {item.service}
                </span>
                <span className="text-xs text-foreground-400">
                  {item.date}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}